import { FormControl } from '@material-ui/core';
import { Field, FormikErrors } from 'formik';
import moment from 'moment';
import * as React from 'react';
import { DatePicker } from './FormikDatePicker';

export interface IDatePickerFieldProps {
    name: string;
    label: string;
    inputId: string;
    required?: boolean;
    fullWidth?: boolean;
    variant?: string;
    clearable?: boolean;
    errorMessage?: FormikErrors<moment.Moment>;
}

export default class DatePickerField extends React.Component<IDatePickerFieldProps> {
    constructor(props: IDatePickerFieldProps) {
        super(props);
    }

    public render() {
        const {
            clearable,
            errorMessage,
            name,
            label,
            inputId,
            required = false,
            fullWidth = false,
            variant,
        } = this.props;
        return (
            <FormControl fullWidth={fullWidth} required={required}>
                <Field
                    format="MMM DD, YYYY"
                    variant={variant}
                    showerror={(errorMessage !== undefined).toString()}
                    label={label}
                    name={name}
                    inputProps={{ id: inputId }}
                    component={DatePicker}
                    required={required}
                    clearable={clearable}
                />
            </FormControl>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/DatePickerField/DatePickerField.tsx